<template>
  <v-dialog v-model="isShow" persistent max-width="640" :retain-focus="false">
    <v-card
      class="update-chart-full pt-8 pl-10 pr-10 pb-4 rounded-0"
      height="auto"
    >
      <div class="">
        <span class="head-search-text">ชื่อสิทธิ์หลัก</span>
        <br />
        <span class="black--text font-weight-bold mr-5 ">{{ data.name }}</span>
        <v-btn
          absolute
          right
          top
          icon
          x-small
          @click="closeDialog()"
          style="z-index: 1;"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
      <v-divider class="mt-1 mb-4" />
      <span class="head-search-text mt-2"
        >บริษัท {{ companyName || "-" }}</span
      >
      <v-row>
        <v-col cols="5" class="pt-5">
          <span>จำนวนสทธิ์ย่อย</span>
          <v-chip :color="'#ECF9FF'" :text-color="'#3776E9'" small class="ml-1">
            <span style="font-size: 15px;">{{ data.totalSubRight || 0 }}</span>
          </v-chip>
        </v-col>
        <v-col cols="7">
          <v-text-field
            v-model="keywordSearch"
            item-text="groupCompanyNameFull"
            item-value="groupCompanyId"
            multiple
            outlined
            dense
            clearable
            class=""
            placeholder="ค้นหา"
            no-data-text="ไม่พบข้อมูล"
            height="5"
            @change="(page = 1), searchByKeyword()"
            @click:clear="(page = 1), (keywordSearch = ''), searchByKeyword()"
            v-on:keyup.enter="(page = 1), searchByKeyword()"
            v-on:keyup="(page = 1), searchByKeyword()"
          >
            <template v-slot:append>
              <img
                width="24"
                height="24"
                src="@/assets/icons/search-icon-2.png"
                style="cursor: pointer;"
                @click="(page = 1), searchByKeyword()"
              />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <div class="text-center mt-0" justify="start">
        <FullLoading :loading="loadingData"></FullLoading>
        <v-data-table
          class="border-table-employee text-no-wrap table-approve"
          item-key="index"
          :headers="headers"
          :items="dataTable"
          :loading="loading"
          loader-height="0"
          loading-text="Loading... Please wait"
          no-data-text="ไม่พบข้อมูล"
          no-results-text="ไม่พบข้อมูล"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100, -1],
            'items-per-page': 15
          }"
          :server-items-length="allCount || -1"
          disable-sort
          @update:items-per-page="changePerPage"
          @update:page="changePage"
          height="450"
        >
          <template v-slot:[`item.no`]="{ item }">
            {{ perPage * (page - 1) + dataTable.indexOf(item) + 1 }}
          </template>
        </v-data-table>
      </div>
      <v-card-actions class="justify-center pb-0">
        <v-btn
          class="mt-2"
          color="primary"
          dark
          elevation="0"
          @click="closeDialog()"
        >
          <span class="font-weight-regular">
            ปิด
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import { insertRequest, hostImageUrlv3, getServiceById } from '@/API/API'
// import swal from 'sweetalert'
// import { EventBus } from '@/EventBus'
import FullLoading from '../../_template/FullLoading.vue'
const axios = require('axios')

export default {
  components: {
    FullLoading
  },
  props: {
    isShow: Boolean,
    data: Object,
    companyId: String,
    orgId: String,
    companyName: String
  },
  data () {
    return {
      dialogShow: false,
      promtDialog: false,
      loadingData: false,
      server: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      loading: false,
      keywordSearch: '',
      dataTable: [],
      dataTableBackup: [],
      dataPure: [],
      allCount: 0,
      headers: [
        {
          text: 'ลำดับ',
          align: 'left',
          value: 'no',
          width: '100px',
          groupable: false,
          sortable: false
        },
        { text: 'สิทธิ์', value: 'name' }
      ],
      page: 1,
      perPage: 15
    }
  },
  computed: {},
  watch: {
    async data () {
      await this.getData()
    }
  },
  mounted () {},
  async created () {
    this.tokenUser = this.$store.state.token
    this.keywordSearch = ''
    this.dataTable = []
    if (this.data) await this.getData()
  },
  beforeDestroy () {
    this.keywordSearch = ''
  },
  methods: {
    async closeDialog () {
      await this.$emit('closeDialogShowSub')
      this.keywordSearch = ''
    },
    changePerPage (value) {
      this.perPage = value
      this.getData()
    },
    changePage (value) {
      this.page = value
      this.setFilter()
    },
    async getData () {
      if (this.data._id) {
        // console.log('test', this.data)
        try {
          await axios({
            // /subRight/:id/:companyId/:orgId
            url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/right/subRight/${this.data._id}/${this.companyId}/${this.orgId}`,
            method: 'GET',
            headers: {
              authorization: this.$store.state.token
            }
          })
            .then(response => {
              if (response.data.success === true) {
                // this.itemsServiceList = response.data.result
                this.dataPure = response.data.result
                this.computeData(this.dataPure)
              } else {
                // this.itemsServiceList = []
                this.dataPure = []
                this.computeData(this.dataPure)
              }
            })
            .catch(function (thrown) {})
        } catch (error) {
        } finally {
        }
      } else {
        this.dataPure = []
        this.computeData(this.dataPure)
      }
    },
    async computeData (data) {
      var result = data.map(e => ({ name: e }))
      this.dataTable = result
      this.dataTableBackup = JSON.parse(JSON.stringify(result))
    },
    async searchByKeyword () {
      this.dataTable = this.dataTableBackup.filter(e => {
        return e.name.includes(this.keywordSearch)
      })
    },
    async clickClear () {
      this.dataTable = this.dataTableBackup.filter(e => {
        return e.name.includes(this.keywordSearch)
      })
    }
  }
}
</script>
<style>
@import "../../../css/Create.css";
@import "../../../css/ShowService.css";
</style>
